<template>
  <div id="myaccount" class="-mx-3 -mt-4">
    <section v-if="errored" class="w-full text-center mt-6">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the school details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <form
      v-on:submit.prevent="submitSchool"
      id="schoolForm"
      ref="form"
      v-if="!isSchoolComplete"
    >

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold"> School Name *</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input
              v-model="school.name"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-title"
              type="text"
              placeholder="Enter school name"
              required=""
            />
          </div>
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold">Postcode *</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input
              v-model="school.postcode"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-title"
              type="text"
              placeholder="Enter postcode"
              required=""
            />
          </div>
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold">Address</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input
              v-model="school.address"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-title"
              type="text"
              placeholder="Enter address"
              required=""
            />
          </div>
        </div>

        <div class="mx-6 pt-1 flex justify-between w-full pb-4">
                    <div class="flex space-x-4  w-full "> 
                 <div >
                  <label class="font-semibold"> City </label>
            <input
              v-model="school.city"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-city"
              type="text"
              placeholder="Enter city"
            />
          </div>

          <div >
            <label class="font-semibold"> County </label>
            <input
              v-model="school.county"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-county"
              type="text"
              placeholder="Enter county"
            />
          </div>
                    
                  </div>

                  </div>

      </div>



      <div  class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold"> PE Lead Contact</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input
              v-model="leadContact"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-postcode"
              type="email"
              placeholder="Enter PE Lead contact email"
            />
          </div>
        </div>
        </div>

        <div  class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold"> Finance Contact</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input
              v-model="financeContact"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-postcode"
              type="email"
              placeholder="Enter PE Lead contact email"
            />
          </div>
        </div>
        </div>


        <footer
                  class="mb-20"
                >
                  <p
                    v-if="validationInError"
                    class="bg-red-400 rounded w-11/12 text-white p-4 mt-2"
                  >
                    <i class="fas fa-exclamation-circle pr-2 text-xl"></i>All
                    required fields must be complete.
                  </p>

                  <div class="h-10 text-left w-11/12 mt-6 ml-6 mb-20 pb-4">
                   <button
                   @click="submitForm()"
          type="button"
                    :disabled="isDisabled"
                    class="publish-button hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed px-4"

                  >
                    Save Changes
                  </button>
                </div>
                </footer>


    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BaseService } from "@/services/school.service";

export default {
  name: "myaccount",
  props: {
    school: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    isDisabled() {
      if (
        (this.school.name == undefined || this.school.name.length > 0) &&
        (this.school.postcode == undefined || this.school.postcode.length > 0)
      ) {
        return false;
      } else {
        return true;
      }
    },
    showForSchool() {
      return this.currentUser.isSchool;
    },
    showForCompany() {
      return this.currentUser.isSchool == false;
    },
  },
  data() {
    return {
      object: {},
      loading: true,
      errored: false,
      leadContact: "",
      financeContact: "",
      isSchoolComplete: false,
      validationInError: false,
    };
  },
  created() {
    this.leadContact =
      this.school.pe_contact == undefined ? "" : this.school.pe_contact;
    this.financeContact =
      this.school.pe_contact == undefined ? "" : this.school.finance_contact;
  },
  methods: {
    submitForm() {
      if (this.$refs.form.requestSubmit === undefined) {
        this.processSchool();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    submitSchool() {
      if (this.school.name == "" || this.school.postcode == "") {
        this.alertDisplay();
      } else {
        this.processSchool();
      }
    },
    alertDisplay() {
      this.$swal({
        title: "Empty Fields",
        text: "You have empty fields that are required",
        type: "warning",
        showCancelButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: true,
      });
    },
    processSchool() {
      this.school.pe_contact = this.leadContact;
      this.school.finance_contact = this.financeContact;

      BaseService.update("owner/school", this.school)
        .then((response) => this.completion(true))
        .catch((err) => {
          this.failure(err)
          // console.log("Account update error " + err);
        });
    },
    completion(val) {
      this.$emit('school-edited')
    },
    failure(error) {
      this.isSchoolComplete = false
      this.errored = true
      console.log("School update error " + error);
    },
  },
  components: {},
};
</script>
<style lang="css" scoped>
.form-label {
  @apply block uppercase tracking-wide text-gray-700 text-xs font-bold  mb-2;
}

.form-input {
  @apply appearance-none block w-full  bg-gray-100  text-gray-700 border border-gray-200  rounded py-3 px-4 mb-3 leading-tight;
}
</style>
